import React from "react";
import "../styles/Footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <span className="footer-logo">© 2023 THE GLITCH</span>. All rights reserved.
        </footer>
    );
};

export default Footer;
